export default __webpack_public_path__ + "sliderImage_2.png";